module.exports = __webpack_public_path__ + "assets/img/wenjianjia.abbca6a3.png";